// 二维码受控管理文件路由

export default [
	{
		path: "/extra/qffile/file_preview/:fileId/:type",
		name: "file_preview",
		component: () => import("@/views/qffile/file_preview"),
		hidden: true,
		meta: {
			title: "文件预览"
		}
	},
	{
		path: "/extra/qffile/group_list/:groupId/:type",
		name: "dept_file_broswer",
		component: () => import("@/views/qffile/group_list"),
		hidden: true,
		meta: {
			title: "浏览"
		}
	}
]